import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getUserGroup } from '../../../User/UserGroupActions';
import { getProductSpecialPriceValue, memoizedGetProducts } from '../../ProductActions';
import { getReferral } from '../../../App/AppActions';

import ProductList from './ProductList';
import ProductSlider from './ProductSlider';

export function ProductHiglightList({ userGroup, products, referral = '', isMobile = false }) {
	return (
		// <ProductList
		// 	products={products.filter(product => getProductSpecialPriceValue(product, 'priceTTC', userGroup, referral) || product.isHighlight).slice(0, 8)}
		// 	hideSorter
		// 	hideFilter
		// 	itemsPerPage={0}
		// 	hideAddToCart
		// />
		<ProductSlider
			products={products.filter(product => getProductSpecialPriceValue(product, 'priceTTC', userGroup, referral) || product.isHighlight).slice(0, 8)}
			countPerSlide={isMobile ? 2 : 4}
			hideAddToCart
		/>
	);
}

ProductHiglightList.propTypes = {
	userGroup: PropTypes.object.isRequired,
	products: PropTypes.arrayOf(PropTypes.object).isRequired,
	referral: PropTypes.string,
};

// Retrieve data from store as props
function mapStateToProps(store) {
    return {
        userGroup: getUserGroup(store),
        products: memoizedGetProducts(store, { isActive: true, isPack: false, isVariation: false }),
        referral: getReferral(store),
		isMobile: store.app.isMobile,
    };
}

export default connect(mapStateToProps)(ProductHiglightList);
